<template>
  <portal to="actionbar">
    <div class="FAContainer" v-show="$slots.actionbuttons || foundActionbuttons">
      <!-- slot op pagina met action buttons of .net action buttons aanwezig -->
      <div class="container">
        <div class="row" id="FixedActions">
          <div class="col-md-10 col-sm-10 col-xs-10" id="FixedActionsButtons">
            <slot name="actionbuttons"></slot
            ><!-- hier komen de action buttons -->
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2" id="FixedActionsJumpHolder" v-if="showJumpMenu()">
            <button
              v-if="!hasJumplist && !isScrollonTop"
              id="PEJumptoTop"
              class="btn btn-default btn-xs"
              onclick="$('html, body').animate({ scrollTop: 0 }, 'slow');return false;"
            >
              <span class="glyphicon glyphicon-arrow-up"></span
              ><span class="totoptext">
                {{ translation(1461) }}
              </span>
            </button>
            <div v-if="hasJumplist" id="FixedActionsJump" class="hideonmenu">
              <div class="dropdown dropdown-large pull-right">
                <button
                  class="btn btn-default dropdown-toggle btn-xs"
                  type="button"
                  id="PEJumpListBtn"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span id="jumptotextheader">{{ translation(2070) }}</span>
                  <span class="glyphicon glyphicon-chevron-down"></span>
                </button>
                <ul
                  class="dropdown-menu dropdown-menu-large ps-container ps-theme-default"
                  id="PEJumpList"
                  aria-labelledby="PEJumpListBtn"
                  data-ps-id="9074340b-d534-2c6e-fd9d-0397e7ed9906"
                  style="max-height: 828px"
                >
                  <li>
                    <a href="#"><span class="glyphicon glyphicon-chevron-up"></span>&nbsp;{{ translation(12590) }}</a>
                  </li>
                  <li v-if="openall">
                    <a href="javascript:void(0)" :onclick="strOpenAll"
                      ><span class="glyphicon glyphicon-eject"></span>&nbsp;{{ this.translation(14102) }}</a
                    >
                  </li>
                  <li v-for="(jumpitem, index) in jumpmenuitems" :key="index">
                    <a :href="'#' + jumpitem.anchor">
                      <font-awesome-icon :icon="jumpitem.icon" />
                      &nbsp;<span v-html="jumpitem.label"></span
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'
export default {
  mixins: [FAMixin],
  name: 'XVactionBar',
  props: {},
  data: function () {
    return {
      foundActionbuttons: false,
      hasJumplist: false,
      openall: false,
      strOpenAll: '',
    }
  },
  methods: {
    ...mapMutations(['addJumpmenuitem']),
    showJumpMenu() {
      return PEGLOBALS.DotnetPage
    },
  },
  mounted: async function () {
    if (PEGLOBALS.DotnetPage) {
      // PEJumpList  Get Jumplist items from Legend tag data
      if ($('legend span:visible').next('a').length !== 0 || $('.BSaccordion .accpaneltitle:visible').length !== 0) {
        this.hasJumplist = true
        /* open alles toevoegen als er accordeons op staan */
        if ($('.BSaccordion .accpaneltitle:visible').length !== 0) {
          let vuethis = this
          $.each($('.BSaccordion.accordeon'), function () {
            // alleen de accordeons die xaujumplistaddopenall op true hebben staan

            if ($(this).data('xaujumplistaddopenall') === true) {
              vuethis.strOpenAll = "OpenAllAccordeons('" + $(this).attr('id') + "');"
              vuethis.openall = true
            }
          })
        }
        /* einde van: open alles toevoegen als er accordeons op staan */

        var jumpliObj = []
        $.each($('legend span:visible'), function () {
          if ($(this).next('a').length !== 0) {
            jumpliObj.push({
              anchor: $(this).next('a').attr('name'),
              label: $(this).html(),
            })
          }
        })

        $.each($('.BSaccordion .accpaneltitle:visible'), function () {
          // alleen voor de sub accordeons een anker aanmaken, ook bij tabbladen geen anker aanmaken
          if (
            $(this).closest('.collapsable').length === 0 &&
            $(this).closest('.tab').data('xaulayout') === 'accordeon'
          ) {
            jumpliObj.push({
              anchor: $(this).data('xauanchorid'),
              label: $(this).html(),
            })
          }
        })
        for (let j of jumpliObj) {
          this.addJumpmenuitem(j)
        }
      }

      if ($('#pnlButtonBar').length !== 0 && $('#pnlButtonBar').html().trim() !== '') {
        this.foundActionbuttons = true
        await this.$nextTick() // wacht op de volgende tik want ik doe hier een ongeoorloofde dom manipulatie!
        $('#pnlButtonBar [data-xmodal]').detach().appendTo('#contentdiv')
        $('#pnlButtonBar').detach().appendTo('#FixedActionsButtons')
      }
      $('#FixedActions button').addClass('btn-xs')

      // haal de asp.net settings op uit het globalpe object
    }
  },
  computed: {
    ...mapGetters(['jumpmenuitems', 'isScrollonTop']),
  },
}
</script>
